<template>
  <div class="row" style="overflow-x: auto; white-space: nowrap">
    <p><em>1 star: dislike, 2 stars: neutral, 3 stars: like</em></p>
    <table class="ui striped selectable table" v-if="students">
      <thead>
        <tr>
          <th></th>
          <th v-for="student in students" v-bind:key="student.id">
            {{ student.lastName }}, {{ student.firstName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in students" v-bind:key="student.id">
          <th>{{ student.lastName }}, {{ student.firstName }}</th>
          <td
            v-for="targetStudent in students"
            v-bind:key="targetStudent.id"
            v-bind:title="getChoiceDisplayText(student, targetStudent)"
          >
            <sui-rating
              v-if="targetStudent.id !== student.id"
              :rating="choicesLocal[student.id][targetStudent.id]"
              :max-rating="3"
              @rate="
                (evt, props) => handleRate(props, student.id, targetStudent.id)
              "
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TestStudentMatrix',
  computed: {
    ...mapGetters({
      schools: 'schools',
      classes: 'classes',
      teachers: 'teachers',
      classStudents: 'classStudents',
    }),
  },
  props: ['students', 'choices', 'new'],
  data() {
    return {
      choicesLocal: null,
    };
  },
  methods: {
    getChoiceDisplayText(student, targetStudent) {
      return `Choice by ${student.firstName} ${student.lastName} for ${targetStudent.firstName} ${targetStudent.lastName}`;
    },
    handleRate(props, studentId, targetStudentId) {
      this.choicesLocal[studentId][targetStudentId] = props.rating;
      this.choicesLocal = Object.assign({}, this.choicesLocal);
      this.$emit('updated', this.choicesLocal);
    },
    updateChoices() {
      if (this.students) {
        if (this.new) {
          this.choicesLocal = {};
          this.students.forEach((student) => {
            this.choicesLocal[student.id] = {};
            this.students.forEach((targetStudent) => {
              this.choicesLocal[student.id][targetStudent.id] = 2;
            });
          });
          this.$emit('updated', this.choicesLocal);
        } else {
          this.choicesLocal = JSON.parse(JSON.stringify(this.choices));
          this.$emit('updated', this.choicesLocal);
        }
      }
    },
  },
  watch: {
    choices() {
      this.updateChoices();
    },
  },
  created() {
    this.updateChoices();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestStudentMatrix.vue